module.exports = __webpack_public_path__ + "static/0003-0e2c9c6b2597672d09ab3772773ae9e0.jpg";